import React from "react";
import { IoMdClose } from "react-icons/io";
import "./input-styled.css";
import {WordTitle} from '../../utils/commonFunction'

const SelectInput = (props: any) => {
  const {
    label,
    disable,
    placeholder,
    id,
    errors,
    name,
    value,
    icon,
    onChange,
    onBlur,
    lableStyle,
    selectStyle,
    divStyle,
    iconStyle,
    onKeyDown,
    required,
    SvgIcon,
    disableColor,
    clearSearch,
    setShowSearch,
    options, // options for the select dropdown
    placeholderDisabled = true,
    valueKey,
    labelKey,
    size
  } = props;

  return (
    <div className={`w-full relative ${divStyle}`}>
      {label && (
        <label
          htmlFor={id}
          className={`font-medium text-[12px] text-[#1C2A3D] leading-[100%]  ${lableStyle}`}
        >
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {/* Select input */}
      <select
        disabled={disable}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        style={{ boxShadow: "0px 1px 2px 0px #1018280D", ...selectStyle }}
        className={`custom-select w-full text-[14px] py-[12px] border rounded-[8px] h-full ${
          errors && "error_msg"
        } px-[14px]  border-[#E6E7E8]  ${selectStyle} disabled:cursor-not-allowed disabled:text-[${disableColor ? '#1C2A3D' : '#DCDCDC'}] focus:outline-none focus:border-[#BEBEBE] leading-[16px] ${
          label && "mt-[6px]"
        } `}

        {...(size !== undefined && { size })}
      >
        {placeholder && (
          <option value="" disabled = {placeholderDisabled}>
            {placeholder}
          </option>
        )}
        {options &&
          options.map((option: any, index: number) => (
            <option key={index} value={option[valueKey]}>
              {
              WordTitle(option[labelKey])}
            </option>
          ))}
      </select>

      {/* Search with clear icon */}
      {icon && (
        value ? (
          <IoMdClose
            color={"black"}
            className={`absolute ${iconStyle || "left-2"} cursor-pointer`}
            onClick={() => {
              clearSearch([]);
              setShowSearch("");
            }}
          />
        ) : (
          <img
            src={icon}
            alt="icon"
            className={`absolute ${iconStyle || "left-2"} cursor-pointer`}
            width={20}
            height={20}
          />
        )
      )}

      {SvgIcon && SvgIcon}
    </div>
  );
};

export default SelectInput;
